import { useState } from "react";
import { Link } from "react-router-dom";
import { api, setToken, errorText } from "@/lib/api";
import { TextField, PrimaryButton } from "./fields";

export default function AdminLogin({ onLogin }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setToken(data.token);
      onLogin({ email: data.email, role: data.role });
    } catch (err) {
      setError(errorText(err, "Unable to sign in."));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-navy px-6" data-testid="admin-login-page">
      <form onSubmit={submit} className="w-full max-w-md border border-navy-ink/10 bg-navy-light/50 p-10" data-testid="admin-login-form">
        <p className="text-[10px] uppercase tracking-[0.45em] text-gold">Modi Marine</p>
        <h1 className="mt-3 font-serif text-4xl font-light text-navy-ink">Private Office</h1>
        <p className="mt-2 text-xs text-mist">Sign in to manage the yacht catalogue.</p>
        <div className="mt-8 space-y-5">
          <TextField label="Email" type="email" required value={email} onChange={setEmail} testId="admin-email-input" placeholder="admin@modimarine.in" />
          <TextField label="Password" type="password" required value={password} onChange={setPassword} testId="admin-password-input" placeholder="••••••••" />
        </div>
        {error && <p className="mt-4 text-xs text-red-700" data-testid="admin-login-error">{error}</p>}
        <PrimaryButton type="submit" disabled={busy} className="mt-8 w-full" data-testid="admin-login-submit">
          {busy ? "Signing in…" : "Sign in"}
        </PrimaryButton>
        <Link to="/" className="mt-6 block text-center text-[10px] uppercase tracking-[0.3em] text-mist hover:text-gold" data-testid="admin-back-to-site">
          Back to site
        </Link>
      </form>
    </div>
  );
}
